import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { round, toTitleCase } from "../../../Others/functions";
import OrderPlaced from "./OrderPlaced";
// import styled from "styled-components";

// const ShopCard = styled.div`
//   display: flex;
//   position: relative;
//   flex-direction: column;
//   margin: 0 auto;
//   padding: 10px;
//   text-align: center;
//   width: 120px;
//   line-height: 1;
//   overflow: hidden;
//   img {
//     width: 100px;
//     height: 100px;
//     margin: 0px auto;
//     border-radius: 20%;
//   }
//   .dot {
//     width: 7px;
//     height: 7px;
//     border-radius: 50%;
//     background-color: #e96125aa;
//     margin: auto 0;
//   }
//   .title {
//     text-overflow: ellipsis;
//     overflow: hidden;
//   }
//   .discount {
//     position: absolute;
//     top: 100px;
//     width: 90px;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     border-radius: 5px;
//     padding: 5px;
//     color: #fff;
//     background-color: #60b246;
//   }
// `;

export default function ThankYou() {
  const [opacity, setOpacity] = useState(1);
  const [zIndex, setIndex] = useState(10000);
  const { state } = useLocation();
  // eslint-disable-next-line
  const [vars, setVars] = useState(state);
  const vendors = useSelector((s) => s.vendor.vendorList);
  const cur = useSelector((s) => s.user.currentLocation);
  const navigate = useNavigate();

  const [nearbyVendors, setNearby] = useState([]);

  useEffect(() => {
    if (vendors && vars && cur) {
      setNearby(
        vendors?.filter(
          (el) =>
            el.deliveryArea
              .map((el) => el.pincode)
              .includes(cur.pincode?.toString()) &&
            el.info.businessName !== vars?.vendor &&
            el.info.status === 1
        )
      );
    }
  }, [vendors, cur, vars]);

  useEffect(() => {
    if (!(vendors && state)) navigate("/");
  }, [vendors, state, navigate]);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(0);
      setIndex(-1);
    }, 1000);
  }, []);
  return (
    <div>
      <OrderPlaced opacity={opacity} zIndex={zIndex} />
      {/* NavBar */}
      <div className="py-2 fixed-top d-flex transition bg-orange text-light">
        <div className="px-3 text-center my-auto">
          <span
            className="bi bi-arrow-left fs-3"
            onClick={() => navigate("/home")}
          ></span>
        </div>
        <div className="w-100 my-auto lh-1 overflow-hidden me-3">
          <div className="fs-5">Order #{vars?.order}</div>
          <div
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              fontSize: "12px",
              paddingLeft: "2px",
            }}
          >
            {vars?.vendor}
          </div>
        </div>
        {/* <div className="w-25 my-auto"></div> */}
      </div>

      {/* Thank You part */}
      <div
        className="d-flex align-items-center p-3 pt-4 pb-2"
        style={{ marginTop: "48px" }}
      >
        <div className="fs-4 lh-sm">
          <span className="text-orange fw-bold fs-3">Thank you</span> for <br />{" "}
          your order{" "}
          <span
            className="bi bi-heart-fill text-danger fs-4"
            style={{ verticalAlign: "top" }}
          ></span>
        </div>
        <div className=" my-auto ms-auto">
          <a
            style={{
              width: "3rem",
              height: "3rem",
              border: "3px solid #fff",
              boxShadow: "0 0 1px 1px #0d6efd",
            }}
            href={`tel:${state?.vendorPhn}`}
            className="rounded-circle bg-primary text-center d-flex"
          >
            <i
              className="bi bi-telephone-fill text-white m-auto fs-5"
              style={{ lineHeight: "inherit" }}
            ></i>
          </a>
        </div>
        <div className="my-auto ms-2">
          <a
            style={{
              width: "3rem",
              height: "3rem",
              border: "3px solid #fff",
              boxShadow: "0 0 1px 1px #60b246",
            }}
            href={`whatsapp://send?phone=91${state.vendorPhn}&text=Hi`}
            className="rounded-circle bg-green text-center d-flex"
          >
            <i
              className="bi bi-whatsapp text-white fs-5 m-auto"
              style={{
                lineHeight: "inherit",
                paddingTop: "1px",
                paddingLeft: "1px",
              }}
            ></i>
          </a>
        </div>
      </div>

      <div className="d-flex align-items-center sep mx-3 round border-0 pt-3">
        <hr className="w-100" />
        <div
          className="px-3 text-center d-flex"
          style={{ whiteSpace: "nowrap" }}
        >
          <span className="text-uppercase text-orange fs-5 fw-bold">
            Your bill
          </span>
        </div>
        <hr className="w-100" />
      </div>
      {/* Billing Summary */}
      <div className="px-3 mt-2">
        <div className="d-flex my-1 fw-bold">
          <div className=" w-100" style={{ fontSize: "16px" }}>
            Description
          </div>
          <div
            className=" text-center"
            style={{ fontSize: "16px", whiteSpace: "nowrap" }}
          >
            Item Total
          </div>
        </div>
        <div className="dotted-hr mb-1"></div>
        {vars?.cart?.map((el, i) => (
          <div key={i} className="d-flex py-2">
            <div className="w-100 lh-sm">
              <div className="">{toTitleCase(el.pName)}</div>
              <div className=" text-muted">
                Qty: <span className="text-dark fw-bold">{el.qty}</span>
                <span className="text-green ">
                  {el.free > 0 ? ` +${el.free} Free` : ""}
                </span>
              </div>
            </div>
            <div className="w-40  mt-auto text-end text-muted fw-bold ps-2">
              ₹{round(el.qty * el.finalSp, 2)?.toLocaleString("en-IN")}
            </div>
          </div>
        ))}
      </div>
      <div className="dotted-hr mx-3"></div>
      <div className="d-flex p-2 ps-0">
        <div className="w-100 ps-3 fs-5 fw-bold">Total :</div>
        <div className="w-50 fs-5 text-end fw-bold pe-2">
          ₹{vars?.bill.Total?.toLocaleString("en-IN")}
        </div>
      </div>
      {vars?.bill?.["cart discount"] ? (
        <div className="d-flex p-2">
          <div className="w-100 ps-3 fw-bold">
            {vars?.bill?.["cart discount"]?.str} :
          </div>
          <div className="w-50 text-end text-muted fw-bold pe-2">
            ₹{vars?.bill?.["cart discount"]?.amt}
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className=" d-flex p-3 my-2"
        style={{
          background: "rgb(211 234 224)",
          borderTop: "1px solid #b3d7c7",
          borderBottom: "1px solid #b3d7c7",
        }}
      >
        <div className="fs-5 fw-bold w-100">Amount Payable:</div>
        <div className="fs-5 fw-bold text-end">
          ₹
          {(vars?.bill?.["Grand Total"] || vars?.bill?.Total)?.toLocaleString(
            "en-IN"
          )}
        </div>
      </div>
      <div className="gap"></div>
      <div className="fixed-bottom w-100 p-2">
        <button
          className="btn-cnf btn-orange w-100 fs-4 py-2"
          onClick={() => navigate("/home")}
        >
          <i className="bi-house-fill fs-4 me-2"></i>Home
        </button>
      </div>
    </div>
  );
}
